<template>
  <div class="discountHome" v-if="data">
    <!--    选择优惠方式-->
    <div class="discountType" @click=onShowDialog>
      <!-- 小程序端/app乘车码页进入展示 -->
      <p class="p1" v-if="!isFromApp || isFromRide">选择优先优惠方式</p>
      <p class="p1" v-else>公交优先优惠方式</p>
      <p class="p2">{{ defaultPay() }}</p>
      <img class="icon" src="../../assets/icon_right_arrow.png">
    </div>
    <!--    可用优惠列表-->
    <van-list>
      <div v-for="item in data" :key="item.index" @click="jumpPage(item.type)">
        <div class="listItem">
          <!--  优惠券图片  -->
          <img class="itemIcon" :src="iconSet(item)">
          <!--  优惠类型  -->
          <p class="itemType">{{ item.name }}</p>
          <!--  优惠描述  -->
          <p class="itemInfo" :class="infoSet(item).class">{{ infoSet(item).info }}</p>
          <img class="icon" src="../../assets/icon_right_arrow.png">
        </div>
      </div>
    </van-list>
    <!--  app端 && 乘车码页进入的使用规则  -->
    <div v-if="isFromApp && isFromRide">
      <p class="rule-description">优惠说明</p>
      <div class="rule">
        <p class="rule-content">1.</p>
        <p class="rule-content">优惠券或折扣卡，不可叠加或同时使用。选择的优先优惠方式如已用尽，自动切换其他可用优惠。</p>
      </div>
      <div class="rule">
        <p class="rule-content">2.</p>
        <p class="rule-content"><span>优惠方式（优惠券/折扣卡）优先于扣款方式，扣款的优惠需满足活动方的条件，</span><span class="rule-info" @click="jumpActivityInfo()">参考具体活动信息。</span>
        </p>
      </div>
      <div class="rule">
        <p class="rule-content">3.</p>
        <p class="rule-content">乘车订单以系统扣款时用户设定的优惠方式和扣款方式为准。</p>
      </div>
      <div class="rule">
        <p class="rule-content">4.</p>
        <p class="rule-content">如用户因支付账户状态问题（包括但不限于卡余额不足、卡冻结、卡销户等状态异常）造成首次扣款失败，后续补缴时按原价支付。</p>
      </div>
    </div>
    <!--  非app端进入的使用规则  -->
    <div v-if="!isFromApp">
      <p class="rule-description">优惠说明</p>
      <div class="rule">
        <p class="rule-content">1.</p>
        <p class="rule-content">优惠券或折扣卡，不可叠加或同时使用。选择的优先优惠方式如已用尽，自动切换其他可用优惠。</p>
      </div>
      <div class="rule">
        <p class="rule-content">2.</p>
        <p class="rule-content">优惠方式（优惠券/折扣卡）优先于扣款方式的支付侧优惠，扣款的优惠需满足活动方的条件。
        </p>
      </div>
      <div class="rule">
        <p class="rule-content">3.</p>
        <p class="rule-content">乘车订单以系统扣款时用户设定的优惠方式和扣款方式为准。</p>
      </div>
      <div class="rule">
        <p class="rule-content">4.</p>
        <p class="rule-content">如用户因支付账户状态问题（包括但不限于卡余额不足、卡冻结、卡销户等状态异常）造成首次扣款失败，后续补缴时按原价支付。</p>
      </div>
    </div>
    <!-- 会员券使用规则 仅app展示-->
    <div v-if="isFromApp">
      <p class="rule-description">会员优惠券说明</p>
      <div class="rule">
        <p class="rule-content">1.</p>
        <p class="rule-content">会员优惠券有效期与会员有效期一致，均为31天，请及时使用。</p>
      </div>
      <div class="rule">
        <p class="rule-content">2.</p>
        <p class="rule-content">提前续费会员后，会员优惠券将于下一会员周期发放，具体发放时间可在会员详情页面查看。</p>
      </div>
    </div>
    <!-- 弹出框 -->
    <div class="dialog" v-show="showDialog" @click="showDialog = false">
      <transition name="fullscreen">
        <div
            v-show="showDialog" @click="showDialog = false"
            class="dialogContent"
            :class="{ dialogContentActive: showDialog }">
          <div v-for="(item, index) in actions" :key="index">
            <div class="item" @click="onSelect(item)">{{ item.name }}</div>
          </div>
          <div class="cancelBtn" @click="showDialog = false">取消</div>
        </div>
      </transition>
    </div>
    <!-- loading组件 -->
    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>
  </div>
</template>

<script>
import {benefitDefault, benefitItem, benefitQuery} from "@/api/HttpService";
import couponIcon from "../../assets/icon_coupons.png"
import cardIcon from "../../assets/icon_card.png"
import Loading from "@/components/loading/loading.vue";


export default {
  name: 'DiscountHomePage',
  components: {Loading},
  data() {
    return {
      // 优惠方式选择框
      showDialog: false,
      // 是否乘车码页进入
      isFromRide: false,
      // 优惠券列表数据
      data: [],
      // 弹框选项数据
      actions: [],
      loading: false,
    };
  },
  computed: {
    isFromApp() {
      return this.$store?.state?.source === 'app';
    }
  },
  mounted: function () {
    document.title = "我的卡券";
    if (this.$route.query.from && this.$route.query.from === 'bus') {
      this.isFromRide = true
    }
    // 获取优惠数据
    this.benefitQuery()
    // 获取优惠方式列表
    this.benefitItem()
  },
  methods: {
    // 获取数据
    benefitQuery: async function () {
      this.loading = true;
      let params = {};
      // 当app从乘车码页进入，只查询乘车券
      if (this.isFromApp && this.isFromRide) {
        params.kind = 10;
      }
      await benefitQuery(params)
          .then(({res}) => {
            if(res.originalData.code == "SUCCESS" && res.originalData.bizCode == "SUCCESS"){
              this.data = res.data
            }else{
              this.$toast(res.originalData.bizMsg || "网络异常")
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast("网络异常");
          });
      this.loading = false;
    },
    // bottom列表选项
    benefitItem: async function () {
      this.loading = true;
      let params = {};
      await benefitItem(params)
          .then(({res}) => {
              if(res.originalData.code == "SUCCESS" && res.originalData.bizCode == "SUCCESS"){
                for (let i in res.data) {
                  this.actions.push({name: res.data[i].info, type: res.data[i].type, info: res.data[i].name})
                }
              }else {
                this.$toast(res.originalData.bizMsg || "网络异常")
              }
          })
          .catch((err) => {
            console.log(err);
            this.$toast("网络异常");
          });
      this.loading = false;
    },
    // 设置默认优惠方式
    benefitDefault: async function (type) {
      this.loading = true;
      let params = {
        type: type,
      };
      await benefitDefault(params)
          .then(({res}) => {
            if(res.originalData.code == "SUCCESS" && res.originalData.bizCode == "SUCCESS"){
              this.$toast('设置成功');
              this.benefitQuery()
            }else{
              this.$toast(res.originalData.bizMsg || "网络异常")
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast("网络异常");
          });
      this.loading = false;
    },
    // 弹出优惠选择框
    onShowDialog() {
      this.showDialog = true
    },
    // 选择默认支付方式
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.showDialog = false;
      this.benefitDefault(item.type)
    },
    // 优惠栏默认显示
    defaultPay: function () {
      if (this.data == null || this.data[0] == null) {
        return ""
      }
      if (this.data[0].use == "1") {
        return this.data[0].name
      }
      return "不使用优惠券/折扣卡"
    },
    // icon 图片显示
    iconSet: function (item) {
      return item.type === "ticket" ? couponIcon : cardIcon
    },
    // 卡券info显示
    infoSet: function (item) {
      if (item.type === "ticket") {
        if (item.detail.count > 0) {
          return {
            info: item.detail.count + "张可用",
            class: "orange"
          }
        }
        return {
          info: item.detail.count + "张可用",
          class: "gray"
        }
      } else {
        if (item.detail.count > 0) {
          return {
            info: item.detail.name,
            class: "orange"
          }
        }
        return {
          info: "无正在使用折扣卡",
          class: "gray"
        }
      }
    },
    // 跳转活动信息QA
    jumpActivityInfo: function () {
      window.location.href = process.env.VUE_APP_PAYQUESTION_URL;
    },
    // 跳转到对应优惠页
    jumpPage: function (type) {
      // 跳转卡详情页
      if (type === "card") {
        this.$router.push({
          name: "cardDetail",
        });
        return
      }
      // 跳转仅展示公交优惠券
      if (this.isFromRide && this.isFromApp) {
        this.$router.push({
          name: "BusCouponListPage",
        });
        return;
      }
      this.$router.push({
        name: "CouponListPage",
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../page/DiscountHomePage/DiscountHomePage.scss";
</style>
